export default __webpack_public_path__ + "static/LinkedinButton-fe6e81788517ee8bccc0d01bc42b47bf.svg";